// @ts-nocheck
import React from "react";
import { useTranslation } from "react-i18next";

const SeoKeyPhrases = () => {
  const { t } = useTranslation();

  const phrases = t("seo-phrase", { returnObjects: true });

  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-6 mt-20">
      {phrases.map((phrase, index) => (
        <p
          key={index}
          className="text-sm text-center text-gray-500 hover:text-gray-600 cursor-pointer transition-colors duration-200"
        >
          {phrase}
        </p>
      ))}
    </div>
  );
};

export default SeoKeyPhrases;
